import * as XLSX from "xlsx";

export function downloadTrends(data, type) {
  if (!data || data.length === 0) {
    console.warn("No data available to download");
    return;
  }

  const format = type?.toLowerCase();

  // ✅ CSV DOWNLOAD
  if (format === "csv") {
    const headers = Object.keys(data[0]);

    const rows = [
      headers.join(","),
      ...data.map(row =>
        headers
          .map(key => {
            const value = row[key] ?? "";
            return `"${String(value).replace(/"/g, '""')}"`;
          })
          .join(",")
      )
    ];
    const blob = new Blob([rows.join("\n")], {
      type: "text/csv;charset=utf-8;"
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "trends.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  // ✅ EXCEL DOWNLOAD
  if (format === "excel") {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Trends");

    XLSX.writeFile(workbook, "trends.xlsx");
  }
}
